<template>
  <div class="teams">
    <div class="row" v-for="i in Math.ceil(sortedTeams.length / 5)" :key="i">
      <div class="cell" 
      v-for="(team, index) in sortedTeams.slice((i - 1) * 6, i * 6)" :key="index"
            :class="{'even': index % 2 === 0, 'odd': index % 2 !== 0 }">
           <Team v-bind:team="team"/>
      </div>
    </div>
  </div>
</template>

<script>
import Team from '@/components/Team.vue'
import getTeamsMixin from '@/data/get-teams-mixin.js'
import { mapActions } from 'vuex'

export default {
  name: 'Teams',
  mixins: [getTeamsMixin],

  components: {
    Team
  },
  created() {
    // Ensure data is loaded when this component is created
    this.ensureDataLoaded()
  },
  computed : {
    sortedTeams() {
        if (!this.teamData.teams || this.teamData.teams.length === 0) {
          return [];
        }
        var clone = this.teamData.teams.slice(0);
        function compare(a, b) {
              if (a.name < b.name)
                return -1;
              if (a.name > b.name)
                return 1;
              return 0;
            }

      return clone.sort(compare);
    }
  },
  methods: {
    ...mapActions('teamData', ['initializeYearFromStorage']),
    async ensureDataLoaded() {
      // Check if we have data, if not, initialize it
      if (!this.teamData || Object.keys(this.teamData).length === 0) {
        await this.initializeYearFromStorage()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
div.cell {
  float: left;
  width: 33%;
  min-width: 240px;
  border: 1px solid grey;
}

@media screen and (max-width: 1000px) {
  div.cell {
    width: 100%;
  }
}

div.even {
  background-color: rgb(255, 255, 255);
  color: black;
}
div.odd {
  background-color: rgb(0, 0, 0);
  color: white;
}
.row:after {
  content: "";
  display: table;
  clear: both;
}
</style>
